import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from '../src/environments/environment';

 if(!environment.api_base_url.includes('localhost')) console.log = () =>{}
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));


